<template>
  <div class="BasePopup" @click.self="handleClickHide" v-show="isPopupShow">
    <div class="detail-box" id="delBox">
      <div class="detail-btn-wrap" id="delBtn" @touchstart="handleTouchStart" @touchend="handleTouchend">
        <div class="detail-btn-inner"></div>
      </div>
      <div class="detail-label">
        {{ instance ? instance.instanceName : instanceName }}
        <div class="detail-sub-label" @click="clickViewDel" v-if="isHas">查看详情 &gt;</div>
      </div>
      <div class="detail-box-text" v-html="instance ? instance.properties.description : '暂无数据'"></div>
    </div>
  </div>
</template>

<script>
import { _throttle } from '@/utils/debounce.js'
import { queryInstanceDetails } from '@/api/http/index'

export default {
  name: 'BasePopup',
  data() {
    return {
      delBtn: null,
      delBox: null,
      delBoxH: null,
      isPopupShow: false,
      instance: null,
      instanceName: '',
      spe: '', //特殊标识
      isHas: true
    }
  },
  created() {},
  mounted() {
    this.$EventBus.$on('openDel', (instanceName, spe = '', obj = {}) => {
      if (instanceName) {
        this.isHas = true

        this.spe = spe
        this.instanceName = instanceName
        const params = { instanceId: instanceName }
        queryInstanceDetails(params).then(
          res => {
            res || (this.isHas = false)
            let str = res.properties.description
            let newStr = str
              .replace(/<[^>]*>/g, '')
              .replace(/&ldquo;/g, '“')
              .replace(/&rdquo;/g, '”')
              .replace(/&nbsp;/g, '')
              .replace(/\n/g, '')
            this.instance = res
            this.instance.properties.description = this.substrByByte(newStr, 160)
            this.getDomEl()
            this.delBox.classList.add('transition')
            // TODO
            setTimeout(() => {
              this.delBox.style.transform = `translate(0,0)`
            }, 0)
          },
          () => {
            // 错误处理
          }
        )
      } else {
        this.isHas = false
        this.instance = {
          instanceName: obj.name,
          properties: {
            description: obj.description
          }
        }
        this.getDomEl()
        this.delBox.classList.add('transition')
        // TODO
        setTimeout(() => {
          this.delBox.style.transform = `translate(0,0)`
        }, 0)
      }
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openDel')
  },
  components: {},
  computed: {},
  methods: {
    // 处理字符串
    substrByByte(str, num) {
      let bytesCount = 0
      // 匹配所有的中文和中文标点
      let pattern = /[\u4e00-\u9fff\u3000-\u303f“”，﹑]+/
      for (let i = 0; i < str.length; i++) {
        let c = str.charAt(i)
        if (!pattern.test(c)) {
          bytesCount += 1
        } else {
          bytesCount += 2
        }
        if (bytesCount > num) {
          return str.substr(0, i) + '...'
        } else if (bytesCount === num) {
          return str.substr(0, i + 1) + '...'
        }
      }
      return str
    },
    // 准备工作
    getDomEl() {
      this.isPopupShow = true

      this.delBtn = document.getElementById('delBtn')
      this.delBox = document.getElementById('delBox')
      // TODO
      setTimeout(() => {
        console.log(this.delBox.offsetHeight, 'this.delBox.offsetHeight')
        this.delBoxH = this.delBox.offsetHeight
      }, 0)

      // 当过渡完成移除过渡效果
      this.delBox.addEventListener('transitionend', () => {
        this.delBox.classList.remove('transition')

        let oldY = this.delBox.style.transform.match(/\((.*)\)/)
        oldY = oldY ? oldY[1].split(',') : 0
        oldY = oldY ? oldY[1].replace(/px/g, '') * 1 : 0
        oldY = Math.abs(oldY)
        const standard = Math.round(this.delBoxH / 4)
        if (oldY >= standard) {
          this.isPopupShow = false
        }
      })
    },
    // 手指按下
    handleTouchStart(e) {
      e.preventDefault()
      // 拿到触摸点坐标
      const startY = e.touches[0].clientY
      const _run = _throttle(e => {
        const currentY = e.touches[0].pageY // 当前点击的点击位置的坐标值
        let moveY = currentY - startY
        if (moveY <= 0) moveY = 0 // 禁止向上拖动
        if (moveY >= this.delBoxH) moveY = this.delBoxH
        this.delBox.style.transform = `translate(0,${moveY}px)`
      }, 15)
      this.delBox.ontouchmove = _run
    },
    // 手指离开
    handleTouchend() {
      const { delBox, delBoxH } = this

      let oldY = delBox.style.transform.match(/\((.*)\)/)
      oldY = oldY ? oldY[1].split(',') : 0
      oldY = oldY ? oldY[1].replace(/px/g, '') * 1 : 0
      oldY = Math.abs(oldY)

      const standard = Math.round(delBoxH / 4)
      if (oldY >= standard) {
        delBox.classList.add('transition')
        delBox.style.transform = `translate(0,${delBoxH}px)`
      } else {
        delBox.classList.add('transition')
        delBox.style.transform = `translate(0,0)`
      }
      delBox.ontouchmove = null

      if (oldY == 0) this.delBox.classList.remove('transition')
    },
    // 点击隐藏
    handleClickHide() {
      this.delBox.classList.add('transition')
      this.delBox.ontouchmove = null
      delBox.style.transform = `translate(0,${this.delBoxH}px)`
    },
    // 点击跳转详情
    clickViewDel() {
      this.$linkWx({ instance: this.instance.instanceId, url: '/pages/InstanceDetail' })
      this.handleClickHide()
    }
  }
}
</script>

<style lang="scss" scoped>
.BasePopup {
  overflow: hidden;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1003;

  width: 100%;
  height: 100%;
  background-color: transparent;
  .detail-box {
    position: absolute;
    bottom: 0;
    left: 0;

    width: inherit;
    // height: 6.45rem;
    // height: 7.35rem;
    padding: 0 0.94rem 0.5rem;
    background-color: #fff;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;

    transform: translate(0, 500px);

    .detail-btn-wrap {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 1.2rem;
      height: 0.8rem;
      padding-top: 0.26rem;
      margin: 0 auto;

      .detail-btn-inner {
        width: 0.8rem;
        height: 0.08rem;
        background-color: #eee2d6;
        border-radius: 0.1rem;
      }
    }

    .detail-label {
      position: relative;

      width: 100%;
      padding: 0.4rem 2.2rem 0.4rem 0;
      border-bottom: 0.01rem solid #caa05a;

      color: #ab7f35;
      font-family: 'sySong';
      font-size: 0.58rem;
      text-align: start;

      // white-space: nowrap; /* 防止文本换行 */
      // overflow: hidden; /* 隐藏超出部分 */
      // text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */

      .detail-sub-label {
        position: absolute;
        top: 0.6rem;
        right: 0;
        width: 2rem;
        // transform: translateY(-50%);
        color: #a0a0a0;
        font-size: 0.38rem;
      }
    }

    .detail-box-text {
      width: inherit;
      // max-height: 4rem;
      margin-top: 0.25rem;

      color: #4c4948;
      font-size: 0.44rem;
      font-family: 'sySong';
      line-height: 0.8rem;
      text-align: justify;

      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      // -webkit-line-clamp: 5; /* 显示的行数 */
      p {
        display: none;
        color: red !important;
      }
      p:nth-child(1),
      p:nth-child(2) {
        display: block;
      }
      p:nth-child(2) {
        width: 100%;
        color: red;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
      }
    }
  }
  .transition {
    transition: 0.5s;
  }
}
</style>


<style lang='scss'>
.detail-box-text {
  p {
    display: none;
  }
  p:nth-child(1),
  p:nth-child(2) {
    display: block;
  }
  p:nth-child(2) {
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
  }
}
</style>